<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">3</p>
        <p class="cabin-family bold">What is your investment objective and risk tolerance?</p>
      </div>

      <div class="literacy-body">
        <p class="">Investing involves a trade-off between risk and return. Historically,
        investors who have received higher average long- term returns have experienced greater
        fluctuations in the value of their portfolio and more frequent losses than investors with
        more conservative investments.</p>
        <p class="">We have provided time periods that indicate how long you might have to
        hold a position in order to recover from a loss. Please keep in mind that it is possible
        that some investments may lose their total value or might take longer to recover. We
        recommend investing into multiple products to address these risks through
        diversification.</p>

        <div class="table-responsive">
          <table class="table text-center">
            <thead>
              <th>Your Investment Objective</th>
              <th>Your Risk Tolerance<sup>*</sup></th>
              <th>Indicative Recovery Periods<sup>**</sup></th>
            </thead>
            <tbody>
              <tr>
                <td>
                <input class="form-check-input lh-14" value="A" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My sole objective is to protect the value of my capital. Time Deposits are one
                example of products that might meet this investment objective.</label>
                </td>
                <td>I am not comfortable in taking any investment risk.</td>
                <td>-</td>
              </tr>

              <tr>
                <td>
                <input class="form-check-input lh-14" value="B" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My objective is to achieve investment returns above deposit rates. Government bonds
                are one example of products that might meet this investment objective.</label>
                </td>
                <td>I am only comfortable in taking a low level of investment risk. (1% - 10 %)</td>
                <td>Up to 2 Years</td>
              </tr>

               <tr>
                <td>
                <input class="form-check-input lh-14" value="C" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My objective is to achieve low to moderate capital growth on my investments.
                Investment- grade corporate bonds are one example of products that might meet this
                investment objective.</label>
                </td>
                <td>I am willing to take moderate levels of investment risk. (10% - 15%)</td>
                <td>2 - 3 Years</td>
              </tr>

              <tr>
                <td>
                <input class="form-check-input lh-14" value="D" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My objective is to achieve moderate to high capital growth on my investments.
                Equity Mutual Funds are one example of products that might meet this investment
                objective.</label>
                </td>
                <td>I am willing to take high levels of investment risk. (15% - 20%)</td>
                <td>3 - 5 Years</td>
              </tr>

              <tr>
                <td>
                <input class="form-check-input lh-14" value="E" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My objective is to achieve substantial capital growth on my investments. Equities
                are one example of products that might meet this investment objective.</label>
                </td>
                <td>I am willing to take significantly high levels of investment risk. (20% - 30%)
                </td>
                <td>Over 5 Years</td>
              </tr>

              <tr>
                <td>
                <input class="form-check-input lh-14" value="F" v-model="risk_tolerance"
                type="radio" id="radio1">
                <label class="form-check-label">
                My objective is to achieve exceptional capital growth on my investments. Private
                Equity is one example of products that might meet this investment objective.</label>
                </td>
                <td>I am willing to take extreme levels of investment risk. (Over 30%)</td>
                <td>Over 5 Years</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="bold">Definitions:</p>
        <ul>
          <li><span class="bold">*Risk Tolerance:</span> This reflects the potential decline you can
          accept on your total holdings on a yearly basis. The ranges have been calculated based on
          historical data and it cannot be guaranteed that these numbers are the absolute maximum.
          You might experience single cases where your volatility might be higher due to extreme
          market conditions. Diversification of assets is strongly recommend to bring down
          volatility in your holdings.</li>
          <li><span class="bold">**Indicative Period (of potential price) Recovery:</span>This is
          the timeframe you would be willing to wait for your total portfolio to recover from a
          decline in value. The ranges have been calculated based on historical data and it cannot
          be guaranteed that these numbers are the absolute maximum. You might need to wait longer
          to achieve full recovery in single cases and you need to be prepared that some investments
          might lose their total value.</li>
        </ul>
      </div>

      <div class="literacy-footer text-center">
        <button class="btn primary-btn btn-block" :disabled="isDisabled" @click="next">Next</button>
        <p class="cabin-family bold mt-2" @click="previous">Previous</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.risk_tolerance) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      risk_tolerance: '',
    };
  },
  methods: {
    next() {
      this.$emit('next', { q3: this.risk_tolerance });
    },
    previous() {
      this.$emit('previous');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.literacy-footer{
    position: relative;
    margin-top: 2rem;
    width: 100%;
  }
.table th, .table td{
  vertical-align: middle;
}
.form-check-label{
  text-align: left;
}
</style>
